import type { FileReplicationStartedResult } from "@/services/abstract/poc/messaging.service.interface";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-replication-started' });

export const createFileReplicationStartedHandler = (): MessageHandler<FileReplicationStartedResult> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-replication-started',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileReplicationStartedResult => {
    if (message.type !== 'file-replication-started') {
      throw new Error(`Invalid message type: expected 'file-replication-started', got '${message.type}'`);
    }

    const { cid, sixId, totalBytes, targetPeerId, sender, timestamp } = message;
    log.info('Received file-replication-started for CID:', cid, 'sixId:', sixId, 'from', sender);

    return {
      cid,
      sixId,
      totalBytes,
      targetPeerId,
      sender,
      messageTimestamp: timestamp
    };
  }
});
